import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { TrustSection } from "@/components/site/TrustSection";
import { BrandMarquee } from "@/components/site/BrandMarquee";
import { About } from "@/components/site/About";
import { Services } from "@/components/site/Services";
import { Conditions } from "@/components/site/Conditions";
import { WhyChooseUs } from "@/components/site/WhyChooseUs";
import { Process } from "@/components/site/Process";
import { Gallery } from "@/components/site/Gallery";
import { Testimonials } from "@/components/site/Testimonials";
import { FAQ } from "@/components/site/FAQ";
import { Booking } from "@/components/site/Booking";
import { Contact } from "@/components/site/Contact";
import { CTA } from "@/components/site/CTA";
import { Footer } from "@/components/site/Footer";
import { FloatingButtons } from "@/components/site/FloatingButtons";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-background overflow-x-hidden">
      <Navbar />
      <Hero />
      <TrustSection />
      <BrandMarquee />
      <About />
      <Services />
      <Conditions />
      <WhyChooseUs />
      <Process />
      <Gallery />
      <Testimonials />
      <FAQ />
      <CTA />
      <Booking />
      <Contact />
      <Footer />
      <FloatingButtons />
    </main>
  );
}
